define('views/physicalstorefolder/index',[],function() {
	'use strict';

	window.assets = window.assets || {};

	require(['classes/lazyload'], function(LazyLoad) {
	    window.assets.lazyload = new LazyLoad().initiate();
	});

	require(['classes/swipeband'], function(swipeBand) {
		window.assets.swipeBand = swipeBand;
		window.assets.swipeBand.initiate(function() {
			console.log('swipeBand initiated the old way');
		});
	});

	require(['classes/filters'], function(filters) {
		window.assets.filters = filters;
		window.assets.filters.initiate(function() {
			console.log('filters initiated the old way');
		});
	});

	require(['classes/stores'], function(stores) {
		window.assets.stores = stores;
		window.assets.stores.initiate(function() {
			console.log('stores initiated the old way');
		});
	});

	require(['classes/lookcarousel'], function(LookCarousel) {
		var lookCarousels = document.querySelectorAll('.look-swiper'),
			i;
		for (i = 0; i < lookCarousels.length; ++i) {
			new LookCarousel({
				element: lookCarousels[i],
				lazyLoad: window.assets.lazyload
			}).initiate();
		}
	});
});
